import { render, staticRenderFns } from "./CommunityCaseDetail.vue?vue&type=template&id=247728c3&scoped=true"
import script from "./CommunityCaseDetail.vue?vue&type=script&lang=js"
export * from "./CommunityCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityCaseDetail.vue?vue&type=style&index=0&id=247728c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247728c3",
  null
  
)

export default component.exports